export class ModelingCategoryCache {
  static indexCacheKey() {
    return `modeling-categories`;
  }
}
